module.exports = __webpack_public_path__ + "static/media/a-hill-away.9f21a149.mp3";